export enum DeliveryMode {
  MANAGED_BY_STORE = 'MANAGED_BY_STORE',
  MANAGED_EXTERNALLY = 'MANAGED_EXTERNALLY',
}
